import {ListItemText} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {ConfirmationPrompt} from "../../../ui/ConfirmationPrompt";
import React, {useState} from "react";
import {resetMachine} from "../../../../api/machine-functions";
import {useApiNotification} from "../../../ui/ApiNotificationProvider";
import ListItem from "@material-ui/core/ListItem";
import {Machine} from "../../../../models/machine.models";

interface MachineResetActionProps extends Machine {
    onActionCompleted: () => void;
}

export const MachineResetAction = (props: MachineResetActionProps) => {
    const {t} = useTranslation();
    const [showConfirmation, setShowConfirmation] = useState(false);
    const {id, onActionCompleted} = props;
    const {showSuccess, handleError} = useApiNotification();
    const [disableReset, setDisableReset] = useState(false);

    const reset = () => {
        setDisableReset(true);
        resetMachine(id)
            .then(() => showSuccess())
            .catch(handleError)
            .finally(() => {
                onActionCompleted();
                setShowConfirmation(false);
                setDisableReset(false);
            });
    }

    return (
        <ListItem onClick={() => setShowConfirmation(true)}>
            <ListItemText style={{cursor: 'pointer'}}>
                {t('Machine.Actions.ResetMachine.Title')}
            </ListItemText>
            <ConfirmationPrompt
                title={t('Machine.Actions.ResetMachine.Title')}
                description={t('Machine.Actions.ResetMachine.Description')}
                open={showConfirmation}
                disable={disableReset}
                onCancel={() => {
                    onActionCompleted();
                    setShowConfirmation(false);
                }}
                onConfirm={() => reset()}
                confirmationButtonKey={'_Common.Labels.Reset'}
            />
        </ListItem>)
}
